type GeneralState = {
  loading: boolean;
};

const generalInitialState: GeneralState = {
  loading: false,
};

export default generalInitialState;
